.fileList {
  list-style: none;
  padding: 0;
  margin: 8px 0;
  border-radius: 6px;
  border: solid 2px var(--border);

  &>li {
    display: flex;
    align-items: center;
    padding: 6px;
    border-bottom: solid 1px var(--border);
    min-height: 30px;

    &:hover {
      background: var(--accent-bg);
      color: var(--accent);
    }

    &>input[type="checkbox"] {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
}

.fileClassification {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.fileName {
  flex: 1;
}

.cursorPointer {
  cursor: pointer;
}